import APIUtils from '@spothero/utils/api';
import UserUtils from 'user/user-utils';

const UserAPI = {
    getLoginStatus() {
        return APIUtils
            .get('users/logged-in/');
    },

    getData() {
        return APIUtils
            .get('users/me/', {
                include: UserUtils.INCLUDES
            });
    },

    lookup(email) {
        return APIUtils
            .get('users/', {
                email,
                include: UserUtils.INCLUDES
            });
    },

    lookupByReservation(reservationId) {
        return APIUtils
            .get('users/', {
                reservation_id: reservationId // eslint-disable-line camelcase
            });
    }
};

export default UserAPI;
